import classNames from 'classnames';
import EFPicture from '@elem/compCommon/EFPicture';
import styles from './index.module.scss';
import { i18nText } from './i18nText';

export enum PAGE_TYPE {
    DELTA_PRO = 'DELTA_PRO',
    DELTA_2_MAX = 'DELTA_2_MAX',
    DELTA_2 = 'DELTA_2',
}

interface Params {
    pageType: PAGE_TYPE;
    locale?: string;
    className?: string;
    theme?: string;
}

const DriveCharge = ({ pageType, locale = 'us', className = '', theme = '' }: Params) => {
    const LANG_TEXT = i18nText[locale]?.[pageType];
    if (!LANG_TEXT) return <></>;
    const prefixCls = 'ef-drive-charge';
    const classString = classNames(prefixCls, styles.DriveCharge, className);

    return (
        <div className={`GtmModuleData-section ${classString}`} id="ef-drive-charge" data-section-id={prefixCls} data-section-title={LANG_TEXT.title}>
            <div className={`wrapper ${theme}`}>
                <p className="title">{LANG_TEXT.title}</p>
                <p className="desc">{LANG_TEXT.desc}</p>
                <div className="view">
                    <div className="area area-a">
                        <EFPicture
                            src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249321557/drive_charge_pc_1.png"
                            srcPad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249228477/drive_charge_h5_1.png"
                            srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249228477/drive_charge_h5_1.png"
                            alt={LANG_TEXT.view_1}
                        />
                        <p className="text" dangerouslySetInnerHTML={{ __html: LANG_TEXT.view_1 }}></p>
                    </div>
                    <div className="area area-b">
                        <EFPicture
                            src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249336557/drive_charge_pc_2.png"
                            srcPad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249249014/drive_charge_h5_2.png"
                            srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249249014/drive_charge_h5_2.png"
                            alt={LANG_TEXT.view_2_top}
                        />
                        <p className="text" dangerouslySetInnerHTML={{ __html: LANG_TEXT.view_2_top }}></p>
                    </div>
                    <div className="area area-c">
                        <EFPicture
                            src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249368346/drive_charge_pc_4.png"
                            srcPad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249260519/drive_charge_h5_3.png"
                            srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249260519/drive_charge_h5_3.png"
                            alt={LANG_TEXT.view_2_bottom}
                        />
                        <p className="text">{LANG_TEXT.view_2_bottom}</p>
                    </div>
                    <div className="area area-d">
                        <EFPicture
                            src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249349969/drive_charge_pc_3.png"
                            srcPad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249273943/drive_charge_h5_4.png"
                            srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249273943/drive_charge_h5_4.png"
                            alt={LANG_TEXT.view_3_top_1}
                        />
                        <div className="text-wrapper">
                            <p className="title-d">{LANG_TEXT.view_3_top_1}</p>
                            <div className="bar-ef"></div>
                            <p className="text text1">{LANG_TEXT.view_3_top_2}</p>
                            <div className="bar-other"></div>
                            <p className="text text2">{LANG_TEXT.view_3_top_3}</p>
                            <p className="text text3">{LANG_TEXT.view_3_top_4}</p>
                        </div>
                    </div>
                    <div className="area area-e">
                        <div className="left">
                            <EFPicture
                                src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249386059/drive_charge_pc_5.png"
                                srcPad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249289182/drive_charge_h5_5.png"
                                srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249289182/drive_charge_h5_5.png"
                                alt={LANG_TEXT.view_3_bottom_left_1}
                            />
                            <p className="text1">{LANG_TEXT.view_3_bottom_left_1}</p>
                            <p className="text2">{LANG_TEXT.view_3_bottom_left_2}</p>
                        </div>
                        <div className="right">
                            <EFPicture
                                src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249399812/drive_charge_pc_6.png"
                                srcPad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249303671/drive_charge_h5_6.png"
                                srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713249303671/drive_charge_h5_6.png"
                                alt={LANG_TEXT.view_3_bottom_right}
                            />
                            <p className="text">{LANG_TEXT.view_3_bottom_right}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DriveCharge;
